import React from 'react';
import { Card, CardContent } from './ui/card';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="disclaimer" className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-yellow-500 uppercase tracking-widest text-sm font-semibold mb-4">
            Contact Us
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Get in Touch
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Have questions? Our team is here to help you navigate your legal requirements.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-16">
          <Card className="bg-slate-800/50 border-slate-700 hover:border-yellow-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/10">
            <CardContent className="p-6 text-center space-y-4">
              <div className="bg-yellow-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto">
                <Mail className="h-6 w-6 text-slate-900" />
              </div>
              <h3 className="text-xl font-semibold text-white">Email</h3>
              <div className="space-y-2">
                <a 
                  href="mailto:soshnitilegal@gmail.com" 
                  className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 block"
                >
                  soshnitilegal@gmail.com
                </a>
                <a 
                  href="mailto:connect@soshnitilegal.com" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors duration-300 block text-sm"
                >
                  connect@soshnitilegal.com
                </a>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-slate-800/50 border-slate-700 hover:border-yellow-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/10">
            <CardContent className="p-6 text-center space-y-4">
              <div className="bg-yellow-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto">
                <Phone className="h-6 w-6 text-slate-900" />
              </div>
              <h3 className="text-xl font-semibold text-white">Phone</h3>
              <div className="space-y-2">
                <a 
                  href="tel:+919665515587" 
                  className="text-gray-300 hover:text-yellow-500 transition-colors duration-300 block"
                >
                  +91-9665515587
                </a>
                <a 
                  href="tel:+918550995532" 
                  className="text-gray-400 hover:text-yellow-500 transition-colors duration-300 block text-sm"
                >
                  +91-8550995532
                </a>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-slate-800/50 border-slate-700 hover:border-yellow-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-yellow-500/10">
            <CardContent className="p-6 text-center space-y-4">
              <div className="bg-yellow-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto">
                <MapPin className="h-6 w-6 text-slate-900" />
              </div>
              <h3 className="text-xl font-semibold text-white">Offices</h3>
              <p className="text-gray-300">
                Pune, Delhi, Mumbai, UAE
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Disclaimer Section */}
        <div className="max-w-4xl mx-auto mt-16">
          <Card className="bg-slate-800/30 border-slate-700">
            <CardContent className="p-8 space-y-6">
              <h3 className="text-2xl font-bold text-white mb-6">Disclaimer</h3>
              
              <div className="space-y-4 text-gray-300 leading-relaxed">
                <p>
                  <strong className="text-white">Information Purposes Only:</strong> You are accessing this website to gain information about Soshniti Legal for your own use. You acknowledge that we have not advertised or solicited for our services.
                </p>
                
                <p>
                  <strong className="text-white">No Attorney-Client Relationship:</strong> Accessing this website and downloading any materials does not create an attorney-client relationship between you and Soshniti Legal.
                </p>
                
                <p>
                  <strong className="text-white">Not Legal Advice:</strong> The information on this website is for informational purposes only and does not constitute legal advice or a legal opinion.
                </p>
                
                <p>
                  <strong className="text-white">Intellectual Property:</strong> All material on this website is the intellectual property of Soshniti Legal.
                </p>
                
                <p>
                  <strong className="text-white">Cookies:</strong> Our website uses cookies to enhance your browsing experience. By using our site, you consent to our use of cookies. For more information, please refer to our Cookies Policy & Privacy Policy.
                </p>
              </div>

              <div className="pt-6 border-t border-slate-700">
                <h4 className="text-xl font-semibold text-white mb-4">About Soshniti Legal</h4>
                <p className="text-gray-300 leading-relaxed">
                  Soshniti Legal is a full-service law firm dedicated to providing comprehensive and high-quality legal solutions to clients across a diverse range of industries and practice areas. With offices in Pune, Delhi, Mumbai, and UAE, we are strategically positioned to serve clients across India and beyond.
                </p>
              </div>

              <div className="pt-6 border-t border-slate-700">
                <h4 className="text-xl font-semibold text-white mb-4">Our Values</h4>
                <p className="text-gray-300 leading-relaxed">
                  At Soshniti Legal, we are guided by the following core values:
                </p>
                <ul className="list-disc list-inside text-gray-300 space-y-2 mt-4">
                  <li><strong className="text-white">Client Focus:</strong> We prioritize understanding our clients' unique needs and objectives, tailoring our services to deliver effective and practical solutions.</li>
                  <li><strong className="text-white">Excellence:</strong> We strive for excellence in every aspect of our work, maintaining the highest standards of professionalism and legal expertise.</li>
                  <li><strong className="text-white">Integrity:</strong> We uphold the highest standards of integrity and ethical standards, earning the trust and confidence of our clients.</li>
                  <li><strong className="text-white">Collaboration:</strong> We foster a collaborative environment, both within our team and with our clients, to ensure that we work together effectively to achieve shared goals.</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;